module.exports = __webpack_public_path__ + "img/transport_detection.57a08e04.png";